<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'
import { onHide, onShow, onUnreadCountChange } from '@intercom/messenger-js-sdk'
import { storeToRefs } from 'pinia'

import { useIntercomSdk } from '~/composables/useIntercomSdk'

import { useMiscIntercomStore } from '~/stores/miscIntercom'

const open = ref(false)
const notificationCount = ref(0)

const { higher: HIGHER } = storeToRefs(useMiscIntercomStore())

useIntercomSdk(() => {
  onUnreadCountChange((count: number) => {
    if (count) notificationCount.value = count
  })

  onShow(() => {
    open.value = true
  })

  onHide(() => {
    open.value = false
  })
})
</script>

<template>
  <div
    id="custom_intercom_button"
    class="tw-fixed tw-left-6 tw-z-[10000] tw-size-15 tw-cursor-pointer tw-transition-all"
    :class="[HIGHER ? 'tw-bottom-20 375:!tw-bottom-24' : 'tw-bottom-6']"
    role="button"
  >
    <div
      v-if="open"
      class="tw-absolute tw-mb-12 tw-ml-12 tw-flex tw-size-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-orange-500 tw-shadow-round"
    >
      <span class="tw-text-sm tw-font-bold tw-text-white">{{
        notificationCount
      }}</span>
    </div>
    <Transition name="fade" mode="out-in">
      <div
        v-if="notificationCount"
        class="tw-absolute tw-mb-12 tw-ml-12 tw-flex tw-size-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-orange-500 tw-shadow-round"
      >
        <span class="tw-text-sm tw-font-bold tw-text-white">{{
          notificationCount
        }}</span>
      </div>
    </Transition>
    <div
      class="tw-flex tw-size-15 tw-items-center tw-justify-center tw-rounded-full tw-bg-orange-500 tw-shadow-round"
    >
      <Transition name="fade" mode="out-in">
        <UIIcon
          v-if="!open"
          name="fa-solid:comment-alt"
          class="tw-text-icon-abovePrimary"
          :class="{ open }"
          size="xl"
          aria-label="Open Intercom chat"
        />
      </Transition>
      <Transition name="rotate" mode="out-in">
        <UIIcon
          v-if="open"
          name="fa-solid:times"
          class="tw-text-icon-abovePrimary"
          size="lg"
          aria-label="Close Intercom chat"
        />
      </Transition>
    </div>
  </div>
</template>

<style scoped lang="scss">
.rotate-enter-active,
.rotate-leave-active {
  @apply tw-absolute tw-transition-transform tw-duration-100 tw-ease-in-out;
}
.rotate-enter-from,
.rotate-leave-to {
  @apply -tw-rotate-90;
}
</style>
